import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.00033 2.66669C8.36851 2.66669 8.66699 2.96516 8.66699 3.33335V11.0572L12.1956 7.52862C12.4559 7.26827 12.878 7.26827 13.1384 7.52862C13.3987 7.78896 13.3987 8.21108 13.1384 8.47142L8.47173 13.1381C8.21138 13.3984 7.78927 13.3984 7.52892 13.1381L2.86225 8.47142C2.6019 8.21108 2.6019 7.78896 2.86225 7.52862C3.1226 7.26827 3.54471 7.26827 3.80506 7.52862L7.33366 11.0572V3.33335C7.33366 2.96516 7.63214 2.66669 8.00033 2.66669Z",
		fill: "currentColor"
	})
});
export default SvgArrowDown;
